export const ITEM_PER_PAGE = 25;
export const ACTIVITY_ORGANIZATION_LIMIT = 5;
export const ACTIVITY_PROJECT_LIMIT = 5;
